import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=187b79ac&scoped=true&"
import script from "./payment.vue?vue&type=script&lang=js&"
export * from "./payment.vue?vue&type=script&lang=js&"
import style0 from "./payment.vue?vue&type=style&index=0&id=187b79ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b79ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('187b79ac')) {
      api.createRecord('187b79ac', component.options)
    } else {
      api.reload('187b79ac', component.options)
    }
    module.hot.accept("./payment.vue?vue&type=template&id=187b79ac&scoped=true&", function () {
      api.rerender('187b79ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/gongdeBox/payment.vue"
export default component.exports